import { pushEventInfo, setPageDetails } from './analytics';
export var setDashboardPageAnalytics = function () {
    var page = {
        category: {
            primaryCategory: 'account dashboard',
            subCategory1: 'account dashboard',
            subCategory2: 'account dashboard',
        },
        pageInfo: {
            pageName: 'account dashboard',
            pageType: 'maml:account dashboard',
        },
    };
    setPageDetails(page);
};
export var dashboardComponentClickAnalytics = function (_a) {
    var component = _a.component, subComponent = _a.subComponent;
    var thdAnalyticsEvent = {
        category: {
            primaryCategory: 'stash',
        },
        eventInfo: {
            eventName: 'my account settings',
        },
        eventMode: 'stash',
        stash: {
            myAccount: {
                settings: "account dashboard: ".concat(component, ": ").concat(subComponent),
            },
        },
    };
    pushEventInfo(thdAnalyticsEvent);
};
